import React, { Component, createContext } from 'react';

export const GlobalContext = createContext(null);
